export const settings = {
    apiKey: process.env.YANDEX_API_KEY,
    coordorder: 'latlong',
    version: '2.1.79',
};
